import React, { useState, useRef, useEffect } from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoIcon from '@material-ui/icons/Info';
import { Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { Parser } from "json2csv";
import { customZip } from "../../utils/ExportShapefile";
import { MoreVertRounded } from '@material-ui/icons';

import '../../scss/components/_externalLayers.scss';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const ExportExternalLayers = (props) => {

    const exportLayersRef = useRef();

    const [showSelActions, setShowSelActions] = useState(false);
    const [topPos, setTopPos] = useState('153px');
    const [selectedItem, setSelectedItem] = useState(null);
    const [exportInProgress, setExportInProgress] = useState(false);
    const [errorDialogue, setErrorDialogue] = React.useState(false);

    const [tmpview, setTmpview] = useState(null);
    const [tmpextent, setTmpextent] = useState(null);

    useEffect(() => {
        if(props.view) {
            setTmpview(props.view);
        }
        if(props.polygonExtent) {
            setTmpextent(props.polygonExtent);
        }
    }, [props.view, props.polygonExtent])

    const handleCloseLayersExport = () => {
        props.setExternalLayersToExport([]);
        props.clearFilterExternalLayers();
    }

    const handleShowActions = (e, ind) => {
        setShowSelActions(true);
        let pos = exportLayersRef.current.getBoundingClientRect();
        let tmp = 153 + (27 * (ind+1));
        setTopPos(tmp+'px');
        setSelectedItem(ind);
    }

    const handleClickAway = () => {
        setShowSelActions(false);
    }

    const handleExportOpt = async(opt) => {
        let layers = [...props.externalLayersToExport];
        let selLayer = layers[selectedItem];
        setShowSelActions(false);
        setExportInProgress(true);
        let time = new Date().getTime();
        let tmpName = selLayer.layerName.split(' ').join('_');
        let filename = `${tmpName}_features_${time}.${opt}`
        let result = "";
        if(opt === "csv") {
            result = generateCSVString(selLayer.features, selLayer.layerType);
        } else if(opt === "json") {
            result = JSON.stringify({"features": selLayer.features});
        } else if(opt === "geojson") {
            result = JSON.stringify(generateGeoJSONString(selLayer.layerType, selLayer.features));
        } else if(opt === "shape") {
            let options = {
                folder: tmpName+'_shape',
                types: {
                    point: tmpName,
                    polygon: tmpName,
                    polyline: tmpName
                }
            };
            let data = generateGeoJSONString(selLayer.layerType, selLayer.features);
            // result = shpwrite.zip(data, options);
            filename = `${tmpName}_features_${time}.zip`
            customZip(data, options, filename);
        }
        if(opt !== "shape") {
            var blob = new Blob([result]);
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        } 
        // else {
        //     let link = document.createElement('a');
        //     link.href = 'data:text/plain;base64,' + result;
        //     link.download = filename;
        //     link.click();
        // }
        setExportInProgress(false);
    }

    const handleDialogueBox = () => {
        setErrorDialogue(!errorDialogue);
    }

    const generateCSVString = (layerFeatures, layerType) => {
        let csv = [];
        layerFeatures.forEach(function(item) { 
            // adding lat and long to the attributes list for point features
            if( layerType === "point" && ((!item.attributes.Latitude && !item.attributes.Longitude) || (!item.attributes.LATITUDE && !item.attributes.LONGITUDE))) {
                item.attributes.LATITUDE = item.geometry[1];
                item.attributes.LONGITUDE = item.geometry[0];
            }
            csv.push(item.attributes); 
        });
        let opts = {};
        let Json2csvParser = new Parser(opts);
        let csvString = Json2csvParser.parse(csv);
        return csvString;
    }

    const generateGeoJSONString = (layerType, layerFeatures) => {
        let tmpType = layerType === "point" ? "Point" : (layerType === "polyline" ? "LineString" : "Polygon");
        let features = layerFeatures.map(function(item){
            let coords = [];
            if(tmpType === "Point") {
                if(item.geometry[0])
                    coords = [parseFloat(item.geometry[0]), parseFloat(item.geometry[1])]
            } else if(tmpType === "LineString") {
                if(item.geometry)
                    coords = item.geometry;
            } else if(tmpType === "Polygon") {
                if(item.geometry)
                    coords = item.geometry;
            }
            return {
                type: 'Feature',
                geometry: {
                    type: tmpType,
                    coordinates: coords
                },
                properties: item.attributes
            }
        });
        let geoJsonFile = {
            type: 'FeatureCollection',
            features: features
        };
        return geoJsonFile;
    }

    const handleExtent = () => {
        props.extentToPolygon();
    }

    return (
        <>
        <div className="exportLayers" ref={exportLayersRef} data-testid="exportLayersContainer">
            <p>
                <label className="layersLbl">External layers 
                    { exportInProgress && <CircularProgress /> }
                </label>
                <img onClick={handleExtent} src={require('../../assets/icons/re-center.svg')} />
            </p>
            <div className="layers-list-cnt">
            {
                props.externalLayersToExport.map( (layer, ind) => {
                return <div className="layer-item">
                    <div className="icon-container">
                    { layer.layerIcon.type === 'image' ?
                        <div><img src={layer.layerIcon.url} className={layer.layerName === 'Crashes' ? 'custom-width' : null} /></div>
                        :
                        layer.layerIcon.type === 'line' ?
                        <div><label style={{width: '14px', backgroundColor: layer.layerIcon.color, height: layer.layerIcon.width+'px', display: 'inline-block' }}></label></div>
                        :
                        layer.layerIcon.type === 'marker' ?
                        <div><label style={{width: '8px', borderRadius: '8px', backgroundColor: layer.layerIcon.color, height: '8px', display: 'inline-block' }}></label></div>
                        :
                        layer.layerIcon.type === 'fill' ?
                        <div><label style={{width: '8px', backgroundColor: layer.layerIcon.color, height: '8px', display: 'inline-block', border: '1px solid' }}></label></div>
                        :
                        null
                    }
                        <label>{layer.layerName}</label> 
                    </div>
                    <div>
                        <label>{layer.features.length}</label>
                        <img src={require('../../assets/icons/action-dots.svg')} onClick={(e) => handleShowActions(e, ind)} />
                    </div>
                    </div>
                })
            }
            </div>
        </div>
        {
            showSelActions &&
            <ClickAwayListener onClickAway={handleClickAway}>
                <div className="selectionActions" style={{top: topPos}} data-testid="actionsContainer">
                    <ul>
                        <li onClick={() => handleExportOpt('csv')}><img src={require('../../assets/icons/file_download.svg')} /> CSV</li>
                        <li onClick={() => handleExportOpt('shape')}><img src={require('../../assets/icons/file_download.svg')} /> Shapefile</li>
                        {/* <li onClick={() => handleExportOpt('json')}><img src={require('../../assets/icons/file_download.svg')} /> Export to feature collection</li> */}
                        <li onClick={() => handleExportOpt('geojson')}><img src={require('../../assets/icons/file_download.svg')} /> GeoJSON</li>
                    </ul>
                </div>
            </ClickAwayListener>
        }
        <Dialog
            open={errorDialogue}
            onClose={handleDialogueBox}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="deletePopup"
        >
            <DialogTitle id="alert-dialog-title" style={{ borderBottom: "1px solid #00A75D", marginRight: '15px', marginLeft: '15px', padding: '7px 0px 0px 21px' }}>
                <Typography component={"h4"} className="header" style={{ marginLeft: "-20px" }}>
                    Error
                <FontAwesomeIcon icon={faTimes} className="crossIcon" onClick={handleDialogueBox} />

                </Typography>
            </DialogTitle>
            <DialogContent>
                <Typography className="errorMsg" >
                    <InfoIcon style={{ color: '#CC0000', marginBottom: '-6px' }} /> File Downloading Failed!
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDialogueBox} className="clearBtn" style={{ border: "1px solid #24618E", borderRadius: '5px', marginBottom: "10px" }}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
        </>
    )
}


export default ExportExternalLayers;